import { FocusTarget } from 'ui/components/primitives';
import { useUpdateEffect } from 'ui/hooks';
import DrawerHeaderBase from './DrawerHeader';
import DrawerWithoutHeader from './DrawerWithoutHeader';
import { Drawer } from './Drawer.components.styles';
import type { DrawerTemplateProps } from './Drawer.components.d';

const DrawerTemplate = ({
  anchor,
  children,
  footer,
  header,
  headerIcon,
  id,
  onClose,
  onDismiss,
  onOpen,
  open,
  size,
  title = '',
  withoutHeader,
  ...props
}: DrawerTemplateProps) => {
  useUpdateEffect(() => {
    if (open && onOpen) {
      onOpen();
    }

    if (!open && onClose) {
      onClose();
    }
  }, [open, onClose, onOpen]);

  return (
    <FocusTarget disabled group="drawer">
      <Drawer.Component
        aria-hidden={open}
        data-anchor={anchor}
        data-id={id}
        data-open={open}
        data-size={size}
        data-testid="drawer"
        role="dialog"
        {...props}
      >
        {!withoutHeader ? (
          <DrawerHeaderBase data-anchor={anchor} headerIcon={headerIcon} onDismiss={onDismiss}>
            {header || title}
          </DrawerHeaderBase>
        ) : (
          <DrawerWithoutHeader data-anchor={anchor} onDismiss={onDismiss} show={open} />
        )}

        <Drawer.Content aria-label="drawer">{children}</Drawer.Content>
        {footer}
      </Drawer.Component>
    </FocusTarget>
  );
};

export default DrawerTemplate;
